import React, { useState } from 'react';
import { CustomCalendar } from '../../Common/CustomCalendar';

interface AchievementRecord {
    id: string;
    productName: string;
    target: number;
    achievement: number;
}

export const TargetAchievement: React.FC = () => {
    const [dateVal, setDateVal] = useState('2026-03-28');

    // Mock products achievement data matching mockup exactly (both showing GOW. Gold Cow Milk 6000ML)
    const [records] = useState<AchievementRecord[]>([
        { id: '1', productName: 'GOW. Gold Cow Milk 6000ML', target: 1000, achievement: 100 },
        { id: '2', productName: 'GOW. Gold Cow Milk 6000ML', target: 1000, achievement: 100 }
    ]);

    return (
        <div className="space-y-6">
            
            {/* ROW 1: Split cards side-by-side */}
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                
                {/* Left Card: Date Filter Card (5 columns width) */}
                <div className="bg-white rounded-3xl border border-[#ECECF2] px-4 py-3 shadow-sm md:col-span-5 flex flex-col justify-between h-48 space-y-4">
                    {/* Header */}
                    <div className="border-b border-slate-100 pb-2 flex items-center justify-between">
                        <span className="text-sm font-bold text-[#1F1F1F] select-none">
                            Target Achievement
                        </span>
                    </div>

                    {/* Choose Date */}
                    <div className="flex-1 pt-1">
                        <CustomCalendar
                            label="Choose Date"
                            value={dateVal}
                            onChange={(val) => setDateVal(val)}
                        />
                    </div>

                    {/* Update button */}
                    <div className="flex items-center justify-center pt-1">
                        <button
                            className="px-6 py-2.5 bg-[#5D4037] hover:bg-[#4E342E] text-white font-bold text-xs rounded-xl cursor-pointer flex items-center gap-1.5 shadow-sm transition-all select-none"
                        >
                            {/* Sync SVG */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M6.18165 1.58557C6.53316 1.58557 6.81826 1.87079 6.81837 2.22229C6.81837 2.57388 6.53323 2.859 6.18165 2.859H3.80665C2.40449 2.8625 1.27054 4.00179 1.27345 5.40393L0.424814 5.40588H0.636728L1.27345 5.40393V10.1813L1.28614 10.441C1.41338 11.7216 2.49206 12.7229 3.80665 12.7262H8.55763C9.8721 12.7228 10.9509 11.7216 11.0781 10.441L11.0908 10.1813V6.9967C11.091 6.64521 11.3761 6.35998 11.7275 6.35998C12.0789 6.36013 12.3641 6.6453 12.3643 6.9967V10.1783L12.3594 10.3746C12.2617 12.3891 10.6001 13.9945 8.56056 13.9996L8.5586 13.0035V13.3629L8.56056 13.9996H3.80372L3.80567 13.3629V13.0035L3.80372 13.9996C1.69839 13.9945 -0.00449816 12.2837 8.92619e-06 10.1783V5.40588C-0.00393784 3.30097 1.69873 1.59068 3.80372 1.58557L3.80567 2.24182V2.22229L3.80372 1.58557H6.18165ZM9.35157 10.3395C9.70306 10.3395 9.98824 10.6246 9.98829 10.9762C9.98829 11.3277 9.70309 11.6128 9.35157 11.6129H3.01368C2.6621 11.6129 2.37696 11.3278 2.37696 10.9762C2.37701 10.6246 2.66213 10.3395 3.01368 10.3395H9.35157ZM9.53419 0.51916C9.93724 0.0123025 10.6353 -0.141615 11.209 0.138301L11.3242 0.201778L11.3887 0.2467L12.7178 1.30529L12.7578 1.33947C13.0145 1.5812 13.159 1.91912 13.1572 2.27209C13.1555 2.5997 13.0259 2.91157 12.7998 3.14611L11.794 4.34924V4.35021L8.35645 8.44885L8.34864 8.45959C8.20162 8.62764 8.00511 8.74564 7.78712 8.79748L7.78028 8.79943L5.99806 9.20373C5.96256 9.21174 5.92599 9.21653 5.88966 9.21838C5.3244 9.24648 4.83185 8.8353 4.7588 8.27404C4.75527 8.24687 4.75294 8.21941 4.75294 8.19201V6.35998C4.75295 6.34567 4.75392 6.33129 4.75489 6.31701C4.77065 6.08618 4.86318 5.86662 5.01856 5.69494L8.38673 1.88732L9.53321 0.517207L9.53419 0.51916ZM6.02638 6.47814V7.89123L7.4297 7.57287L10.0547 4.44104C9.76058 4.32053 9.50145 4.1495 9.28321 3.95959C9.08099 3.78365 8.90605 3.58664 8.75782 3.3883L6.02638 6.47814ZM10.6455 1.28186C10.6041 1.2647 10.5552 1.27564 10.5274 1.31213C10.5216 1.31963 10.5158 1.32735 10.5098 1.33459L9.62306 2.39221C9.747 2.59725 9.91409 2.8202 10.1191 2.99865C10.3802 3.22578 10.6623 3.35291 10.9785 3.3385L11.8272 2.32385C11.8439 2.30378 11.8627 2.28506 11.8818 2.26721L10.6455 1.28186Z" fill="white" />
                            </svg>
                            Update
                        </button>
                    </div>
                </div>

                {/* Right Card: High-Fidelity Mockup Bar Chart Card (7 columns width) */}
                <div className="bg-white rounded-3xl border border-[#ECECF2] px-4 py-3 shadow-sm md:col-span-7 flex flex-col justify-between h-48">
                    {/* Legend Header */}
                    <div className="flex items-center gap-4 select-none pb-1">
                        <div className="flex items-center gap-1.5 text-[10px] font-bold text-emerald-600">
                            <span className="w-2.5 h-2.5 bg-emerald-600 rounded-xs block" />
                            Target
                        </div>
                        <div className="flex items-center gap-1.5 text-[10px] font-bold text-[#C62828]">
                            <span className="w-2.5 h-2.5 bg-[#C62828] rounded-xs block" />
                            Achievement
                        </div>
                    </div>

                    {/* Chart Container Canvas Area */}
                    <div className="bg-[#EFEFEF] rounded-2xl p-3 flex-1 flex gap-2 relative border border-[#E0E0E0]">
                        
                        {/* Y-Axis Labels */}
                        <div className="flex flex-col justify-between text-[9px] font-bold text-slate-500 w-6 h-full py-1 text-right pr-1 select-none">
                            <span>1.0</span>
                            <span>0.5</span>
                            <span>0.0</span>
                            <span>-0.5</span>
                            <span>-1.0</span>
                        </div>

                        {/* Chart Grid Lines & Empty State Label */}
                        <div className="flex-1 border-l border-b border-slate-300 relative flex flex-col justify-between py-1 pr-4">
                            <div className="border-t border-slate-200/50 w-full" />
                            <div className="border-t border-slate-200/50 w-full" />
                            <div className="border-t border-slate-350 w-full" /> {/* baseline */}
                            <div className="border-t border-slate-200/50 w-full" />
                            
                            {/* Rotation sideways labels */}
                            <div className="absolute left-[-20px] top-1/2 -translate-y-1/2 -rotate-90 text-[8px] font-bold text-slate-400 select-none hidden md:block">
                                VALUES
                            </div>

                            {/* DateRange and Title under stickers */}
                            <div className="absolute inset-0 flex flex-col items-center justify-end pb-1 select-none pointer-events-none">
                                <span className="text-[9px] font-bold text-slate-700">
                                    From 30-04-2020 To 30-04-2020
                                </span>
                                <span className="text-[8px] font-semibold text-slate-400 tracking-wider">
                                    DateRange
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            {/* ROW 2: Product Achievement List Card */}
            <div className="bg-white rounded-3xl border border-[#ECECF2] px-4 py-3 shadow-sm space-y-4">
                
                {/* Table Container */}
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse min-w-[700px]">
                        <thead>
                            <tr className="bg-[#FFF9F3] text-[11px] font-bold text-slate-500 select-none">
                                <th className="py-3.5 px-4 rounded-l-xl">Product</th>
                                <th className="py-3.5 px-4">Target</th>
                                <th className="py-3.5 px-4 rounded-r-xl">Achievement</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {records.map((rec, idx) => (
                                <tr key={`${rec.id}-${idx}`} className="hover:bg-slate-50/50 transition-colors">
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.productName}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.target}
                                    </td>
                                    <td className="py-3.5 px-4 text-xs font-semibold text-slate-800">
                                        {rec.achievement}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>

        </div>
    );
};

export default TargetAchievement;
